/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

/**
 * @module
 * @description
 * Entry point for all public APIs of the common/testing package.
 */

export * from './private_export';
export {SpyLocation} from './location_mock';
export {MockLocationStrategy} from './mock_location_strategy';
export {
  MOCK_PLATFORM_LOCATION_CONFIG,
  MockPlatformLocation,
  MockPlatformLocationConfig,
} from './mock_platform_location';
export {provideLocationMocks} from './provide_location_mocks';
